import { Backbone } from '../../vendor';
import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

  urlRoot : '/prices',

  initialize () {
    // temporary
    delete this.attributes.created_by;
    delete this.attributes.modified_by;
    InboomaBaseModel.prototype.initialize.apply(this);
  },

  /**
   * @function Backbone.Model.get
   * @param {*} attr
   */
  get (attr) {

    if (this.attributes[attr] != '' &&
        this.attributes[attr] != null && (
        attr == 'amount' ||
        attr == 'amount_weekday_1' ||
        attr == 'amount_weekday_2' ||
        attr == 'amount_weekday_3' ||
        attr == 'amount_weekday_4' ||
        attr == 'amount_weekday_5' ||
        attr == 'amount_weekday_6' ||
        attr == 'amount_weekday_7')) {

        // from '2.33' or '2.3' to '2,33'
        // OR: return Number(this.attributes[attr]).toLocaleString("de-DE", {minimumFractionDigits: 2});
        return Number(this.attributes[attr]).toFixed(2).replace('.',',');

    } else {
      // Backbone.js -> l441
      return this.attributes[attr];
    }
  },

  /**
   * @function Backbone.Model.set
   */
  set (key, val, options) {
    // Format price accordingly
    // Shall be extended to format more patterns

    //console.log('set price', key, val);

    if (key == null) return this;

    if (val != '' && (
        key == 'amount' ||
        key == 'amount_weekday_1' ||
        key == 'amount_weekday_2' ||
        key == 'amount_weekday_3' ||
        key == 'amount_weekday_4' ||
        key == 'amount_weekday_5' ||
        key == 'amount_weekday_6' ||
        key == 'amount_weekday_7')) {

      if (String(val).indexOf(',') >= 0) {
        val = String(val).replace(',','.');
      }

      val = Number(val).toFixed(2);

    }

    // Backbone.js -> l464
    return Backbone.Model.prototype.set.call(this, key, val, options);

  },

  unsetWeekdayAmounts() {
    this.set('amount_weekday_1', '');
    this.set('amount_weekday_2', '');
    this.set('amount_weekday_3', '');
    this.set('amount_weekday_4', '');
    this.set('amount_weekday_5', '');
    this.set('amount_weekday_6', '');
    this.set('amount_weekday_7', '');
    return this;
  },

  defaults : {
    "id" : "",
    "pricetariff_id" : "",
    "pricetype_id"  : "", // obsolet
    "amount" : "",
    "amount_weekday_1" : "",
    "amount_weekday_2" : "",
    "amount_weekday_3" : "",
    "amount_weekday_4" : "",
    "amount_weekday_5" : "",
    "amount_weekday_6" : "",
    "amount_weekday_7" : "",
  }
})